// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {SchedulingFormModuleLayout} from 'app_components/modules/admin/landings/schedulingForm'
// @end

// @import events
// @end

// @import utils
import { I18nUtil } from 'app_utils/i18n'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
// @end

// @import services
import LandingService from 'app_services/admin/landings/landingService'
import PermissionService from 'app_services/secure/permission/permissionService'
// @end

// @import types
// @end

// @ADD Component types
interface ISchedulingFormModuleProps {
  listOfSchedulings: Array<any>
  source: string
  onHandleSchedulingSubmit: (data: any) => void | null
}
interface ISchedulingFormModuleState {}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class SchedulingFormModule extends Component<ISchedulingFormModuleProps, ISchedulingFormModuleState> {

  public moduleName: string = 'module:landings'
  private permission: PermissionService
  private i18nUtil: I18nUtil
  private screenNotifications: ScreenNotificationsUtil
  private landingService: LandingService

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: ISchedulingFormModuleProps) {
    super(props)
    this.state = {}

    this.permission = new PermissionService(this.moduleName)
    this.i18nUtil = new I18nUtil()
    this.screenNotifications = new ScreenNotificationsUtil()
    this.landingService = new LandingService()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {}

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  public onHandleSchedulingRemove = async (data: any) => {
    let confirm = this.screenNotifications.fire({
      message: `${this.i18nUtil.getTranslate('modules.teacher_landing_form.scheduling.delete_alert.message')}`,
    },
    {
      type: 'warning',
      title: `${this.i18nUtil.getTranslate('modules.teacher_landing_form.scheduling.delete_alert.title')}`,
      confirmButtonText: `${this.i18nUtil.getTranslate('components.screen_notifications.buttons.confirmButtonText')}`,
      cancelButtonText: `${this.i18nUtil.getTranslate('components.screen_notifications.buttons.cancelButtonText')}`,
      showCancelButton: true,
    })

    if (confirm) {
      confirm.then(async (result) => {
        if (result.value) {
          this.setState({loadingForm: 'loading'})

          const remove = await this.landingService.removeScheduling(this.props.source, data)

          this.setState({loadingForm: null})

          if (remove) {
            let screen_notification_label = 'components.screen_notifications.delete'

            this.screenNotifications.fireToast(
              {
                message: `${this.i18nUtil.getTranslate(screen_notification_label)}`,
              },
              {
                position: 'top',
              }
            )

            if(this.props.onHandleSchedulingSubmit !== null){
              this.props.onHandleSchedulingSubmit({status: 'success'})
            }
          }
        }
      })
    }
  }

  render() {
    return(
      <SchedulingFormModuleLayout
        {...this.props}
        permission={this.permission}
        onHandleSchedulingSubmit={this.permission.check(`permission:landings_${this.props.source}_scheduling`, this.props.onHandleSchedulingSubmit)}
        onHandleSchedulingRemove={this.permission.check(`permission:landings_${this.props.source}_scheduling`, this.onHandleSchedulingRemove)}
      />
    )
  }
}

export default connect(mapStatesToProps)(SchedulingFormModule)
